// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile =  {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:3b66daba-dd9f-4d72-ab6c-4badb9e4db3e",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_e7KXzJ1rx",
    "aws_user_pools_web_client_id": "5joosct9qbm7u160vootpiumb5",
    "aws_mobile_analytics_app_id": "f56b9385282743cda5894aaa038992bd",
    "aws_mobile_analytics_app_region": "us-east-1"
};


export default awsmobile;
